import { ReactComponent as CustomerIcon } from '../assets/images/sidebar/CustomerIcon.svg';
import { ReactComponent as SelectedCustomerIcon } from '../assets/images/sidebar/SelectedCustomerIcon.svg';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const VisitorListMenu = {
    id: 'visitor-list',
    title: 'Visitor List',
    type: 'item',
    name: 'visitor',
    url: '/visitor/visitor-list',
    icon: CustomerIcon,
    selected_icon: SelectedCustomerIcon,
    breadcrumbs: false
};

export default VisitorListMenu;
